var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.883826C22.3948 0.629391 21.698 0.77 21.2342 1.24052L18.1478 4.37591V2.46461C18.1484 1.10357 17.0621 0 15.7218 0H2.42606C1.08631 0 0 1.10357 0 2.46461V11.5354C0 12.8964 1.08631 14 2.42606 14H15.7218C17.0615 14 18.1478 12.8964 18.1478 11.5354V9.62409L21.2342 12.7595C21.5446 13.0742 21.9586 13.2416 22.3804 13.2416C22.5889 13.2416 22.7992 13.2002 23 13.1162C23.6051 12.8617 24 12.2616 24 11.5957V2.40374C24 1.73843 23.6051 1.13826 23 0.883826ZM11.4029 7.63852L8.09607 10.2194C7.95526 10.3296 7.7845 10.3862 7.61313 10.3862C7.4939 10.3862 7.37406 10.3588 7.26261 10.3034C6.99179 10.1677 6.82042 9.88826 6.82042 9.58087V4.41913C6.82042 4.11235 6.99179 3.83235 7.26261 3.69722C7.53344 3.56148 7.8564 3.59374 8.09607 3.78122L11.4029 6.36209C11.5983 6.51426 11.7127 6.75043 11.7127 7.00061C11.7127 7.25017 11.5983 7.48635 11.4029 7.63852Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.dde55634.svg";
export { ForwardRef as ReactComponent };